import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "dept-selector-add-text"
};
import { ref, computed, h, useAttrs } from 'vue';
import { useFormDisabled, useFormSize } from 'element-plus';
import DeptTag from './DeptTag.vue';
import DeptPicker from './DeptPicker.vue';
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'index',
  props: {
    modelValue: {
      type: [Array, String, Number],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择部门'
    },
    hideAddButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const DeptIcon = {
      props: {
        size: {
          type: Number,
          default: 16
        }
      },
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24',
          style: {
            width: `${this.size}px`,
            height: `${this.size}px`
          }
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4'
        })]);
      }
    };
    const $props = __props;
    const $emits = __emit;
    const attrs = useAttrs();
    const pickerRef = ref();
    const formDisabled = useFormDisabled();
    const formSize = useFormSize();
    const disabled = computed(() => {
      return formDisabled.value || $props.disabled;
    });
    const sizeName = computed(() => {
      const s = formSize.value || 'default';
      if (s === 'small') return 'small';
      if (s === 'large') return 'large';
      return 'default';
    });
    const isEmpty = computed(() => {
      if (!$props.modelValue) return true;
      return Array.isArray($props.modelValue) && $props.modelValue.length === 0;
    });
    const clickable = computed(() => !disabled.value && !$props.hideAddButton);
    const valueArr = computed(() => {
      if (!$props.modelValue) return [];
      return Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue];
    });
    const openPicker = () => {
      if (!clickable.value) return;
      pickerRef.value?.open();
    };
    const onClose = id => {
      if (!$props.modelValue) return;
      if ($props.multiple && Array.isArray($props.modelValue)) {
        const newValue = $props.modelValue.filter(item => {
          const itemId = typeof item === 'object' ? item.id : item;
          return String(itemId) !== String(id);
        });
        $emits('update:modelValue', newValue);
      } else {
        $emits('update:modelValue', null);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(DeptPicker, {
        ref_key: "pickerRef",
        ref: pickerRef,
        multiple: __props.multiple,
        "model-value": __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event))
      }, null, 8, ["multiple", "model-value"]), _createElementVNode("div", _mergeProps(_unref(attrs), {
        class: ["dept-selector dept-wrapper", {
          'is-disabled': disabled.value,
          'is-empty': isEmpty.value,
          'is-clickable': clickable.value
        }],
        onClick: openPicker
      }), [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueArr.value, item => {
        return _openBlock(), _createBlock(DeptTag, {
          closable: !disabled.value,
          disabled: disabled.value,
          key: typeof item === 'object' ? item.id : item,
          id: typeof item === 'object' ? item.id : item,
          name: typeof item === 'object' ? item.name : '',
          onClose: $event => onClose(typeof item === 'object' ? item.id : item)
        }, null, 8, ["closable", "disabled", "id", "name", "onClose"]);
      }), 128)), _withDirectives(_createElementVNode("span", {
        class: "dept-selector-placeholder"
      }, _toDisplayString(__props.placeholder), 513), [[_vShow, isEmpty.value]]), !__props.hideAddButton && !disabled.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["dept-selector-add", `is-${sizeName.value}`]),
        onClick: _withModifiers(openPicker, ["stop"])
      }, [_createVNode(DeptIcon, {
        size: sizeName.value === 'small' ? 12 : 14
      }, null, 8, ["size"]), _createElementVNode("span", _hoisted_1, _toDisplayString(isEmpty.value ? '选择' : ''), 1)], 2)) : _createCommentVNode("", true)], 16)], 64);
    };
  }
});